import BreadCrumbs from '~src/modules/reports/reportsHeader/components/BreadCrumbs';
import {
  AdminFeedbackCyclePageContainer,
  HeaderContainer,
  ContentWrapper,
  BreadCrumbsContainer,
  HeaderTitleContainer,
  TitleContainer,
  StatusBoxContainer,
  HeaderContentContainer,
} from './AdminFeedbackCyclePage.styled';
import { getBreadCrumbLinks, getTabs } from './constants';
import { useTranslation } from 'react-i18next';
import AvatarBox, { AvatarType } from '~src/shared/avatarBox/AvatarBox';
import StatusBox from '~src/shared/StatusBox';
import useAdminFeedbackCycle from '~src/hooks/api/adminFeedback/useAdminFeedbackCycle';
import { Route, Switch, useHistory, useParams } from 'react-router';
import { translateContent } from '~src/services/translationServices';
import Tabs from '~src/modules/reports/reportsHeader/components/Tabs';
import { routes } from '~src/routingConfig';
import SettingsTab from './Tabs/SettingsTab/SettingsTab';
import CompletionTab from './Tabs/CompletionTab/CompletionTab';

const AdminFeedbackCyclePage = () => {
  const { t } = useTranslation();
  const params = useParams<{ id: string }>();
  const history = useHistory();

  const { data: adminFeedbackCycle } = useAdminFeedbackCycle(params.id);

  const translatedName = adminFeedbackCycle?.name ? translateContent(adminFeedbackCycle.name) : '...';

  return (
    <AdminFeedbackCyclePageContainer>
      <HeaderContainer>
        <ContentWrapper>
          <HeaderContentContainer>
            <BreadCrumbsContainer>
              <BreadCrumbs smallHeader={false} breadCrumbLinks={getBreadCrumbLinks(t, translatedName)} />
            </BreadCrumbsContainer>

            <HeaderTitleContainer>
              <AvatarBox size={80} type={AvatarType.Total} iconName={'iconLightBulb'} />

              <TitleContainer>
                <h3>
                  <>{t('x.admin.feedback.cycle.feedback_meetings')}</>
                </h3>
                <h2>{translatedName}</h2>
                <StatusBoxContainer>
                  <StatusBox active={adminFeedbackCycle?.active} />
                </StatusBoxContainer>
              </TitleContainer>
            </HeaderTitleContainer>

            <Tabs
              noTabs={false}
              tabs={getTabs(params.id)}
              selectedTabIndex={0}
              status=""
              tabSelect={(tab) => {
                history.push(tab.link);
              }}
            />
          </HeaderContentContainer>
        </ContentWrapper>
      </HeaderContainer>

      <ContentWrapper>
        <Switch>
          <Route
            exact
            path={[
              routes.contentScales.adminFeedbackCycle(params.id),
              `${routes.contentScales.adminFeedbackCycle(params.id)}/settings`,
            ]}
            component={() => <SettingsTab adminFeedbackCycle={adminFeedbackCycle} />}
          />
          <Route
            exact
            path={`${routes.contentScales.adminFeedbackCycle(params.id)}/completion`}
            component={() => <CompletionTab adminFeedbackCycle={adminFeedbackCycle} />}
          />
        </Switch>
      </ContentWrapper>
    </AdminFeedbackCyclePageContainer>
  );
};

export default AdminFeedbackCyclePage;
